import { render, staticRenderFns } from "./service-upsert-form-items.vue?vue&type=template&id=46207b94&"
import script from "./service-upsert-form-items.vue?vue&type=script&lang=ts&"
export * from "./service-upsert-form-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports